"use client";

import { c as _c } from "react/compiler-runtime";
import { User } from "lucide-react";
import LinkButton from "@/components/ui/Link";
interface Props {
  isLoggedIn: boolean;
  displayName: string;
}
export function HeaderProfileDesktop(t0) {
  const $ = _c(4);
  const {
    isLoggedIn,
    displayName
  } = t0;
  if (isLoggedIn) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <User size={24} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== displayName) {
      t2 = <LinkButton href="/account" className="flex items-center flex-col h-10" variant="blur" size="lg" title={"\u067E\u0631\u0648\u0641\u0627\u06CC\u0644"}><div className="flex items-center">{t1} <span className="text-sm mt-1">{displayName}</span></div></LinkButton>;
      $[1] = displayName;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LinkButton href="/login" className="flex items-center h-10" variant="blur" size="lg" title={"\u067E\u0631\u0648\u0641\u0627\u06CC\u0644"}><User size={24} /><span className="text-sm">ورود</span></LinkButton>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}